import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../../Components/Layout/Navbar';
import Footer from '../../Components/Layout/Footer';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [pathname]);

  return null;
};

const NonAuthLayout = (props) => {
  return (
    <React.Fragment>
      <Navbar />
      <ScrollToTop />
      {props.children}
      <Footer />
    </React.Fragment>
  );
};

export default NonAuthLayout;
